import { AxiosResponse } from 'axios';
import { call, put, takeLatest, select } from 'redux-saga/effects';

import {
  GET_USER_IDENTITY,
  GET_RECRUITER,
  SHOW_LOADER,
  HIDE_LOADER,
  GET_MODULES,
} from '../constants/ActionTypes';
import {
  getUserIdentityApi,
  getRecruiterApi,
  getModulesApi,
} from '../api/auth.api';
import { DO_CENTRAL_SERVICE_URL } from '../constants/AppConstants';
import { IInitialState } from '../types/initialState.types';

function* getUserIdentity() {
  try {
    const getUserIdentityResp: AxiosResponse = yield call(getUserIdentityApi);

    yield put({
      type: SHOW_LOADER,
      payload: {
        show: true,
      },
    });

    if (getUserIdentityResp && getUserIdentityResp?.data.user_id) {
      yield put({
        type: `${GET_USER_IDENTITY}_SUCCESS`,
        payload: getUserIdentityResp.data,
      });
    } else {
      const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
      window.location.replace(redirectUrl);
    }
  } catch (error) {
    const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
    window.location.replace(redirectUrl);
  } finally {
    yield put({
      type: HIDE_LOADER,
    });
  }
}

function* getRecruiter() {
  const { user_role_id: userRoleID, username } = yield select(
    (state: IInitialState) => state.auth.userIdentityData
  );
  try {
    const getRecruiterResp: AxiosResponse = yield call(
      getRecruiterApi,
      userRoleID,
      username
    );
    if (getRecruiterResp) {
      yield put({
        type: `${GET_RECRUITER}_SUCCESS`,
        payload: getRecruiterResp.data,
      });
    } else {
      const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
      window.location.replace(redirectUrl);
    }
  } catch (error) {
    const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
    window.location.replace(redirectUrl);
  }
}

function* getModules() {
  try {
    const getModulesResp: AxiosResponse = yield call(getModulesApi);
    if (getModulesResp) {
      yield put({
        type: `${GET_MODULES}_SUCCESS`,
        payload: getModulesResp.data,
      });
    } else {
      const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
      window.location.replace(redirectUrl);
    }
  } catch (error) {
    const redirectUrl = `${DO_CENTRAL_SERVICE_URL}/login?next=${window.location.href}`;
    window.location.replace(redirectUrl);
  }
}

export default function* loadAuthSaga() {
  yield takeLatest(GET_USER_IDENTITY, getUserIdentity);
  yield takeLatest(GET_RECRUITER, getRecruiter);
  yield takeLatest(GET_MODULES, getModules);
}
